<div @fade class="smartMate-header">
    <img class="m10-logo" src="/assets/images/mitre10-logo.svg" alt="Mitre10 logo">
    <img class="smartmatelogo" src="/assets/images/SmartMatelogo.png" alt="Mitre10 smartMate logo">
    <p class="m10t-text1 m10t-color-white">{{accountType}}</p>
</div>